import { graphql } from 'gql';

export const catalogRatiosHistoryItemsGql = graphql(`
    query catalogRatioHistoryItems(
        $order: [CatalogRatioHistoryDataSortInput!]
        $skip: Int
        $take: Int
        $where: CatalogRatioHistoryDataFilterInput
        $changeType: HistoryChangeType
    ) {
        catalogRatioHistoryItems(order: $order, skip: $skip, take: $take, where: $where, changeType: $changeType) {
            items {
                catalogRatioId
                id
                isHeadLine
                ratioType
                code
                name
                catalogRatioGroupId
                catalogRatioGroupName
                justification
                changeType
                changeDate
                changeData {
                    name
                    nameCng
                    kmat
                    kmatCng
                    ktz
                    ktzCng
                    ktzzpm
                    ktzzpmCng
                    kozp
                    kozpCng
                    knr
                    knrCng
                    ksp
                    kspCng
                    kem
                    kemCng
                    justification
                    justificationCng
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogRatiosHistoryStatusCountsGql = graphql(`
    query catalogRatioHistoryStatusCounts(
        $startDate: DateTime!
        $endDate: DateTime!
        $where: ServiceDataResultOfHistoryStatusCountDataFilterInput
    ) {
        catalogRatioHistoryStatusCounts(startDate: $startDate, endDate: $endDate, where: $where) {
            data {
                newCount
                updatedCount
                deletedCount
            }
        }
    }
`);

export const catalogRatiosHistoryCodeFilterGql = graphql(`
    query catalogRatioHistoryCodeFilter(
        $startDate: DateTime!
        $endDate: DateTime!
        $changeType: HistoryChangeType
        $where: FilterValueOfStringFilterInput
    ) {
        catalogRatioHistoryCodeFilter(
            startDate: $startDate
            endDate: $endDate
            changeType: $changeType
            where: $where
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogRatiosHistoryNameFilterGql = graphql(`
    query catalogRatioHistoryNameFilter(
        $startDate: DateTime!
        $endDate: DateTime!
        $changeType: HistoryChangeType
        $where: FilterValueOfStringFilterInput
    ) {
        catalogRatioHistoryNameFilter(
            startDate: $startDate
            endDate: $endDate
            changeType: $changeType
            where: $where
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogRatiosHistoryTypeFilterGql = graphql(`
    query catalogRatioHistoryTypeFilter($startDate: DateTime!, $endDate: DateTime!, $changeType: HistoryChangeType) {
        catalogRatioHistoryTypeFilter(startDate: $startDate, endDate: $endDate, changeType: $changeType) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogRatiosHistoryGroupFilterGql = graphql(`
    query catalogRatioHistoryGroupFilter(
        $startDate: DateTime!
        $endDate: DateTime!
        $changeType: HistoryChangeType
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        catalogRatioHistoryGroupFilter(
            startDate: $startDate
            endDate: $endDate
            changeType: $changeType
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogRatiosHistoryJustificationFilterGql = graphql(`
    query catalogRatioHistoryJustificationFilter(
        $startDate: DateTime!
        $endDate: DateTime!
        $changeType: HistoryChangeType
        $where: FilterValueOfStringFilterInput
    ) {
        catalogRatioHistoryJustificationFilter(
            startDate: $startDate
            endDate: $endDate
            changeType: $changeType
            where: $where
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
